import { Grid } from '@mui/material';
import { IconButtonExportExcel } from 'components/iconButtons/IconButtonExportExcel';
import React from 'react';

interface IProps {
    children?: React.ReactNode;
    onExportData: () => void;
}

export const DashFooterExport: React.FC<IProps> = ({ onExportData, children }) => {
    return (
        <Grid container direction="row" justifyContent={"flex-end"}>
            {children && <Grid size="grow">{children}</Grid>}
            <Grid>
                <IconButtonExportExcel color="primary" onClick={onExportData} />
                {/* <MprcLink onClick={onExportData} color="primary"><IconExcel size="2x" /></MprcLink> */}
            </Grid>
        </Grid>
    );
};
